import { JwtPayload } from "jwt-decode";

export enum Groups {
  RCM_ADMINS = "RCMAdmins",
  RCM_MEMBERS = "RCMMembers",
  RCM_PRACTICE_ADMINS = "RCMPracticeAdmins",
  RCM_PRACTICE_STAFF = "RCMPracticeStaff",
  RCM_FRONT_DESK_STAFF = "RCMFrontDeskStaff",
  RCM_OCC_HEALTH = "RCMOccHealth",
  RCM_PAYMENTS = "RCMPayments",
  RCM_DME_BILLING = "RCMDmeBilling",
  RCM_VBC_BILLING = "RCMVbcBilling",
}

export const rcmGroups = [
  Groups.RCM_ADMINS,
  Groups.RCM_MEMBERS,
  Groups.RCM_PRACTICE_ADMINS,
  Groups.RCM_FRONT_DESK_STAFF,
  Groups.RCM_OCC_HEALTH,
  Groups.RCM_PRACTICE_STAFF,
  Groups.RCM_PAYMENTS,
  Groups.RCM_DME_BILLING,
  Groups.RCM_VBC_BILLING,
];

export enum Permissions {
  CREATE_QUEUE = "billinghub:create-queue",
  UPDATE_QUEUE = "billinghub:update-queue",
  LIST_TEAMS = "billinghub:list-teams",
}

export type AccessToken = JwtPayload & {
  groups?: string;
  permissions?: string;
  email?: string;
  carbonUserId?: string;
  practiceId?: string;
  practiceIds?: string;
};
